import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button as AntdButton,
    Row,
    Spin,
    Skeleton,
    Divider,
    List
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useRef, useState } from 'react';
import { createBeaconType } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import useAxiosPrivateFile from '@/context/UseAxiosPrivateFileUploads';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { exportBilledBeaconToExcel, exportFailedUploadBeaconsToExcel } from '@/utils/ExcelDataExport';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Button } from "@/components/ui/button"



const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showbillBeaconDrawer: boolean;
    setShowbillBeaconDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}
const BillBeaconDrawer: React.FC<ProductsDrawerProps> = ({ showbillBeaconDrawer, setShowbillBeaconDrawer }) => {

    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()
    const [file, setFile] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const fileInputRef: any = useRef(null)
    const [alerts, setAlerts] = useState([])
    const axiosPrivateFile = useAxiosPrivateFile()
    const [failedata, setFailedData] = useState<any[]>([])
    const onCLose = () => {
        setShowbillBeaconDrawer(false)
        setFailedData([])
    }
    const handleFileChange = (e: any) => {
        const selectedFile = e.target.files[0]
        if (selectedFile && selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            setFile(selectedFile);
        } else {
            alert('Please upload a valid Excel file (.xlsx)');
        }
    }
    const handleUpload = async () => {
        setFailedData([])
        if (!file) return
        const reader = new FileReader()
        reader.onload = async (e: any) => {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: 'array' })
            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]
            const jsonData: any = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false })
            const maxColumns = Math.max(...jsonData.map((row: any[]) => row.length));
            const headerRow = jsonData[0]
            let missingDataFound = false
            jsonData.forEach((row: any[], rowIndex: number) => {
                if (rowIndex === 0) return
                for (let colIndex = 0; colIndex < maxColumns; colIndex++) {
                    const cell = row[colIndex];
                    if (cell === null || cell === undefined || cell === '') {
                        missingDataFound = true;
                        console.warn(`Missing data in row ${rowIndex + 1}, column ${colIndex + 1}`);
                    }
                }
            })
            const formData = new FormData()
            formData.append('file', file)
            onFinish(formData)
        }
        reader.readAsArrayBuffer(file)
    }
    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json')
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error)
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (formData: any) => {
        setLoading(true)
        let isMounted = true
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivateFile.post('/api/v1/billings/uploadFile', formData, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((response: any) =>
            response.data
        ).then((data) => {
            if (isMounted) {
                successNotification(
                    "File uploaded successfully!",
                    "",
                    'topRight'
                )
                setFailedData(data)
                handleCancel()
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setLoading(false)
        })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    const handleCancel = () => {
        setFile(null)
        setLoading(false)
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const loadData = () => { }

    return (
        <>
            <Drawer
                title="bill Beacons"
                width={720}
                onClose={onCLose}
                open={showbillBeaconDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <AntdButton onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </AntdButton>
                    </div>
                }
            >
                <div className="flex flex-col items-start space-y-4">
                    <label className="block">
                        <span className="sr-only">Upload Excel File</span>
                        <input
                            type="file"
                            accept=".xlsx"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            className="text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                        />
                    </label>

                    {file && (
                        <div className="flex items-center space-x-4">
                            {loading ? (
                                <div className="flex items-center space-x-2">
                                    <span className="text-blue-500 animate-pulse">Uploading...</span>
                                    <button
                                        onClick={handleCancel}
                                        className="text-red-500 hover:text-red-700 font-bold text-lg"
                                    >
                                        X
                                    </button>
                                </div>
                            ) : (
                                <div className="flex items-center space-x-2">
                                    <span className="text-green-500">{file.name}</span>
                                    <button
                                        onClick={handleUpload}
                                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                    >
                                        Upload
                                    </button>
                                    <button
                                        onClick={handleCancel}
                                        className="text-red-500 hover:text-red-700 font-bold text-lg"
                                    >
                                        X
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div>
                    {failedata.length > 0 && (
                        <Button
                            variant="outline"
                            className="ml-auto flex items-center space-x-2"
                            onClick={(() => exportBilledBeaconToExcel(failedata, "EezyTrackBilledBeaconStatus"))}
                        >
                            <ArrowDownTrayIcon className="h-5 w-5" />
                            <span>Export</span>
                        </Button>
                    )}
                    {failedata.length > 0 && (
                        <InfiniteScroll
                            dataLength={failedata?.length ? failedata.length : 0}
                            next={loadData}
                            hasMore={failedata?.length < 0 ? failedata?.length < 0 : false}
                            loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                            endMessage={<Divider plain>{`🤐 Total uploaded  beacon(s) ${failedata?.length}`}</Divider>}
                            scrollableTarget="scrollableDiv"
                        >
                            <List
                                dataSource={failedata}
                                renderItem={(item) => (
                                    <List.Item key={item.beacon}>
                                        <List.Item.Meta
                                            avatar={""}
                                            title={item.beacon}
                                        />
                                        <div>{item.status}</div>
                                    </List.Item>
                                )}
                            />
                        </InfiniteScroll>
                    )}
                </div>
            </Drawer>
        </>
    )
}

export default BillBeaconDrawer;


